export * from './affiliates-in-campaign-page.component';